(function () {
  "use strict";

  var STORE = "";
  var PREVIEW_LOCAL =
    window.FB_PREVIEW_LOCAL === true ||
    /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);

  function productHref(handle) {
    if (PREVIEW_LOCAL) {
      var url = "/live/products/" + encodeURIComponent(handle);
      if (window.FB_PREVIEW_THEME_ID) {
        url += "?preview_theme_id=" + encodeURIComponent(window.FB_PREVIEW_THEME_ID);
      }
      return url;
    }
    if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root !== undefined) {
      return (window.Shopify.routes.root || "/") + "products/" + encodeURIComponent(handle);
    }
    var store = (window.FB_STORE_URL || STORE).replace(/\/$/, "");
    return store + "/products/" + encodeURIComponent(handle);
  }

  function productLinkTarget() {
    return PREVIEW_LOCAL ? "" : "";
  }
  var STAR =
    '<svg class="rating__star" viewBox="0 0 15 15" fill="currentColor"><path d="M7.5 0L9.59 5.27 15 5.73l-4.13 3.71L12.14 15 7.5 12.02 2.86 15l1.27-5.56L0 5.73l5.41-.46z"/></svg>';
  var CAROUSEL_ARROW_PREV =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M15 6l-6 6 6 6"/></svg>';
  var CAROUSEL_ARROW_NEXT =
    '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M9 6l6 6-6 6"/></svg>';

  var BEST_SELLERS = [
    "uti",
    "daily-balance-gummy",
    "flow-balance",
    "zinc-complete",
  ];

  var HERO_BANNERS = [
    {
      image: "hero-banners/fb-home-hero-wellness-simplified.png",
      href: "#shop-by-benefit",
      alt: "Wellness, simplified - Feminine Balance supplements for every stage of her cycle and life",
    },
    {
      image: "hero-banners/fb-home-hero-subscribe-15.png",
      href: "#bestsellers",
      alt: "Get 15% off your subscription order - Subscribe and save on Feminine Balance supplements",
    },
    {
      image: "hero-banners/fb-home-hero-gummies.png",
      href: productHref("daily-balance-gummy"),
      alt: "A balanced life starts here - Fem Gummies daily balance formula",
    },
    {
      image: "hero-banners/fb-home-hero-hormonal-balance.png",
      href: productHref("myo-d-chiro-inositol"),
      alt: "Your journey to natural hormonal balance - Myo and D-Chiro Inositol and Flow Balance",
    },
  ];

  var BENEFIT_GROUPS = [
    { id: "all", label: "All Products", handles: null },
    {
      id: "womens-wellness",
      label: "Women's Health",
      handles: [
        "balance-complex",
        "uti",
        "flow-balance",
        "meno-bal",
        "fem-de-bloat",
        "myo-d-chiro-inositol",
        "dim-complex",
        "daily-balance-gummy",
        "zinc-complete",
        "magnesium-complex",
        "b-complex",
        "calcium-complete",
        "omega-complete",
        "vitamin-d3-k2-complete",
      ],
    },
    { id: "vaginal-flora", label: "Vaginal & Flora", handles: ["balance-complex", "dim-complex"] },
    { id: "urinary", label: "Urinary Support", handles: ["uti"] },
    {
      id: "cycle-pms",
      label: "Cycle & PMS",
      handles: [
        "flow-balance",
        "dim-complex",
        "fem-de-bloat",
        "magnesium-complex",
        "zinc-complete",
        "b-complex",
      ],
    },
    {
      id: "menopause",
      label: "Menopause Support",
      handles: [
        "meno-bal",
        "calcium-complete",
        "vitamin-d3-k2-complete",
        "magnesium-complex",
      ],
    },
    {
      id: "pcos",
      label: "PCOS & Hormones",
      handles: [
        "myo-d-chiro-inositol",
        "dim-complex",
        "choline-complete",
        "b-complex",
        "omega-complete",
      ],
    },
    {
      id: "digestion",
      label: "Digestion & Bloating",
      handles: ["fem-de-bloat", "fiber-complete"],
    },
    {
      id: "daily-nutrition",
      label: "Daily Nutrition",
      handles: [
        "daily-balance-gummy",
        "zinc-complete",
        "magnesium-complex",
        "b-complex",
        "omega-complete",
        "vitamin-d3-k2-complete",
        "calcium-complete",
        "choline-complete",
        "potassium-complete",
        "fiber-complete",
      ],
    },
    /* Dedicated Deficiency Line carousel - catalog products with line: fembal-deficiency */
    { id: "deficiency", label: "Deficiency Support", line: "fembal-deficiency" },
  ];

  var STORIES = window.FB_STORIES || [
    { name: "Kayla, 41", handle: "daily-balance-gummy", quote: "Daily Balance Gummy", tagline: "Wellness you actually enjoy", video: "videos/gummies-showcase.mp4" },
    { name: "Sarah, 34", handle: "balance-complex", quote: "Balance Complex", tagline: "Total feminine flora support", video: "videos/balance-complex-showcase.mp4" },
    { name: "Jessica, 29", handle: "flow-balance", quote: "Flow Balance", tagline: "Easier periods, less pain", video: "videos/flow-balance-showcase.mp4" },
    { name: "Nicole, 32", handle: "fem-de-bloat", quote: "Fem De-Bloat", tagline: "Beat the bloat, fast", video: "videos/fem-de-bloat-showcase.mp4" },
    { name: "Amanda, 38", handle: "uti", quote: "Urinary Tract Balance", tagline: "Daily urinary tract defense", video: "videos/uti-showcase.mp4" },
    { name: "Diane, 52", handle: "meno-bal", quote: "Meno Bal", tagline: "Cooler nights, calmer days", video: "videos/meno-bal-showcase.mp4" },
  ];

  var catalog = [];
  var shopProducts = {};
  var pdpHeroImages = {};
  var pdpHoverImages = {};
  var shopifyCache = {};
  var heroIndex = 0;
  var heroTimer;
  var storyActiveCard = null;
  var storyAutoplayTimer;

  function esc(s) {
    return String(s || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function titleCase(s) {
    return String(s || "").trim().replace(/\b\w/g, function (ch) {
      return ch.toUpperCase();
    });
  }

  function imgUrl(src) {
    if (!src) return "";
    if (src.indexOf("//") === 0) return "https:" + src;
    return src;
  }

  /* Same source order as Shopify PDPs: Admin product media, then PDP gallery asset. */
  function shopifyImageFromRecord(record) {
    if (!record) return "";
    if (record.featured_image) return imgUrl(record.featured_image);
    if (record.images && record.images.length) return imgUrl(record.images[0]);
    return "";
  }

  function pdpGalleryImage(handle) {
    var file = pdpHeroImages[handle];
    if (!file) return "";
    return (window.FB_PDP_HERO_URLS && window.FB_PDP_HERO_URLS[handle]) || "";
  }

  function pdpHoverImage(handle) {
    var file = pdpHoverImages[handle];
    if (!file) return "";
    return (window.FB_PDP_HOVER_URLS && window.FB_PDP_HOVER_URLS[handle]) || "";
  }

  function productCardMediaHtml(href, p, img, opts) {
    var hover = opts.featured ? pdpHoverImage(p.handle) : "";
    if (hover && hover !== img) {
      return (
        '<a href="' + esc(href) + '"' + productLinkTarget() + ' class="product-card__media">' +
          '<img class="product-card__img product-card__img--primary" src="' + esc(img) + '" alt="' + esc(p.displayName) + '" loading="lazy" />' +
          '<img class="product-card__img product-card__img--hover" src="' + esc(hover) + '" alt="" loading="lazy" aria-hidden="true" />' +
        "</a>"
      );
    }
    return (
      '<a href="' + esc(href) + '"' + productLinkTarget() + '>' +
        '<img src="' + esc(img) + '" alt="' + esc(p.displayName) + '" loading="lazy" />' +
      "</a>"
    );
  }

  /* Product pages show theme gallery images first; Shopify admin media is fallback. */
  function productImage(p, shopifyJs) {
    var fromPdp = pdpGalleryImage(p.handle);
    if (fromPdp) return fromPdp;

    var fromJs = shopifyImageFromRecord(shopifyJs);
    if (fromJs) return fromJs;

    return shopifyImageFromRecord(shopProducts[p.handle]);
  }

  function fetchShopify(handle) {
    if (shopifyCache[handle]) return shopifyCache[handle];
    shopifyCache[handle] = fetch("/products/" + encodeURIComponent(handle) + ".js")
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
    return shopifyCache[handle];
  }

  function stars(count) {
    var html = "";
    for (var i = 0; i < 5; i++) html += STAR;
    return html;
  }

  function productCard(p, shopify, opts) {
    opts = opts || {};
    var href = productHref(p.handle);
    var img = productImage(p, shopify);
    var badge = opts.badge !== false ? '<span class="product-card__badge">Save 15%</span>' : "";

      return (
      '<article class="product-card' + (opts.featured ? " product-card--featured" : "") + '">' +
        '<div class="product-card__figure">' +
          badge +
          (img ? productCardMediaHtml(href, p, img, opts) : "") +
        "</div>" +
        '<div class="product-card__info">' +
          '<div class="product-card__title"><a href="' + esc(href) + '"' + productLinkTarget() + ">" + esc(p.displayName) + "</a></div>" +
          '<a href="' + esc(href) + '#reviews" class="rating" aria-label="Customer reviews">' +
            '<div class="rating__stars" aria-hidden="true">' + stars(5) + "</div>" +
          "</a>" +
          '<a class="btn-shop" href="' + esc(href) + '"' + productLinkTarget() + ">Shop Now</a>" +
        "</div>" +
      "</article>"
    );
  }

  function initSnapCarousel(carousel, dotsEl, itemSelector, autoplayMs) {
    if (!carousel || !dotsEl) return;

    var activeIndex = 0;
    var autoplayTimer = null;
    var mobileMq = window.matchMedia("(max-width: 999px)");

    function getItems() {
      return carousel.querySelectorAll(":scope > " + itemSelector);
    }

    function setActive(index) {
      activeIndex = index;
      var items = getItems();
      var dots = dotsEl.querySelectorAll(".page-dots__btn");
      items.forEach(function (item, i) {
        item.classList.toggle("is-selected", i === index);
      });
      dots.forEach(function (dot, i) {
        dot.setAttribute("aria-current", i === index ? "true" : "false");
      });
    }

    function goTo(index, smooth) {
      var items = getItems();
      if (!items.length) return;
      var next = ((index % items.length) + items.length) % items.length;
      var item = items[next];
      carousel.scrollTo({
        left: item.offsetLeft - carousel.offsetLeft,
        behavior: smooth ? "smooth" : "auto",
      });
      setActive(next);
    }

    function resetAutoplay() {
      clearInterval(autoplayTimer);
      autoplayTimer = null;
      if (!autoplayMs || !mobileMq.matches) return;
      autoplayTimer = setInterval(function () {
        goTo(activeIndex + 1, true);
      }, autoplayMs);
    }

    function rebuildDots() {
      var items = getItems();
      if (!items.length) return;
      dotsEl.innerHTML = Array.from(items).map(function (_, i) {
        return (
          '<button type="button" class="page-dots__btn" aria-current="' + (i === 0 ? "true" : "false") + '" aria-label="Go to item ' + (i + 1) + '">' +
            '<span class="sr-only">Go to item ' + (i + 1) + "</span>" +
          "</button>"
        );
      }).join("");
    }

    rebuildDots();

    if (carousel.dataset.snapInit === "true") return;
    carousel.dataset.snapInit = "true";

    dotsEl.addEventListener("click", function (e) {
      var dot = e.target.closest(".page-dots__btn");
      if (!dot) return;
      var dots = dotsEl.querySelectorAll(".page-dots__btn");
      var index = Array.prototype.indexOf.call(dots, dot);
      if (index < 0) return;
      goTo(index, true);
      resetAutoplay();
    });

    carousel.addEventListener("scroll", function () {
      var items = getItems();
      if (!items.length) return;
      var center = carousel.scrollLeft + carousel.clientWidth / 2;
      var closest = 0;
      var closestDist = Infinity;
      items.forEach(function (item, i) {
        var itemCenter = item.offsetLeft - carousel.offsetLeft + item.offsetWidth / 2;
        var dist = Math.abs(center - itemCenter);
        if (dist < closestDist) {
          closestDist = dist;
          closest = i;
        }
      });
      setActive(closest);
    }, { passive: true });

    if (autoplayMs) {
      mobileMq.addEventListener("change", resetAutoplay);
      resetAutoplay();
    }
  }

  function renderCarousel(el, handles, opts) {
    opts = opts || {};
    var products = handles.map(function (h) {
      return catalog.find(function (p) { return p.handle === h; });
    }).filter(Boolean);

    if (!products.length) {
      el.innerHTML = '<p class="loading">Loading products…</p>';
      return;
    }

    el.innerHTML = products.map(function (p) {
      return productCard(p, shopProducts[p.handle] || null, opts);
    }).join("");

    Promise.all(products.map(function (p) {
      return fetchShopify(p.handle).then(function (s) { return { p: p, s: s }; });
    })).then(function (rows) {
      el.innerHTML = rows.map(function (r) { return productCard(r.p, r.s, opts); }).join("");
    });
  }

  function heroBannerStem(imagePath) {
    return imagePath.replace(/^hero-banners\//, "").replace(/\.(png|webp|jpg)$/i, "");
  }


  function heroBannerPicture(banner, i) {
    var stem = heroBannerStem(banner.image);
    var urls = (window.FB_HERO_ASSETS && window.FB_HERO_ASSETS[stem]) || {};
    var loading = i === 0 ? "eager" : "lazy";
    var decoding = i === 0 ? ' decoding="sync"' : ' decoding="async"';
    var priority = i === 0 ? ' fetchpriority="high"' : "";
    var src2048 = urls["2048"] || "";
    var src4096 = urls["4096"] || "";
    if (!src2048 || !src4096) return "";

    /* Serve full PNG assets from Shopify CDN — desktop gets 4096, mobile gets 2048. */
    return (
      '<picture>' +
        '<source media="(min-width: 900px)" srcset="' + esc(src4096) + '">' +
        '<img src="' + esc(src2048) + '" alt="' + esc(banner.alt) + '" width="4096" height="2284" loading="' + loading + '"' + decoding + priority + " />" +
      "</picture>"
    );
  }

  function initHero() {
    var slidesEl = document.getElementById("hero-slides");
    var banners = HERO_BANNERS;

    if (!banners.length) {
      slidesEl.innerHTML = '<div class="slideshow__slide slideshow__slide--banner is-active"><img src="hero-banners/fb-home-hero-subscribe-15.png" alt="Feminine Balance" loading="eager" width="1024" height="571" /></div>';
      return;
    }

    slidesEl.innerHTML = banners.map(function (banner, i) {
      var active = i === 0 ? " is-active" : "";
      var external = banner.href.charAt(0) !== "#";
      var linkTarget = external ? ' target="_blank" rel="noopener"' : "";
      return (
        '<a class="slideshow__slide slideshow__slide--banner' + active + '" href="' + esc(banner.href) + '"' + linkTarget + ">" +
          heroBannerPicture(banner, i) +
        "</a>"
      );
    }).join("");

    syncHeroTrackLayout();
    startHeroAutoplay();
    document.getElementById("hero-prev").addEventListener("click", function (e) { e.preventDefault(); moveHero(-1); });
    document.getElementById("hero-next").addEventListener("click", function (e) { e.preventDefault(); moveHero(1); });
  }

  function syncHeroTrackLayout() {
    var track = document.getElementById("hero-slides");
    if (!track) return;

    // Same viewport-fit frame as before; images use cover to fill full width.
    track.classList.add("slideshow__track--fit-viewport");
    track.classList.remove("slideshow__track--crop-top");
    document.documentElement.style.removeProperty("--hero-crop-track-h");
    document.documentElement.style.removeProperty("--hero-crop-visible");
    document.documentElement.style.removeProperty("--hero-crop-top");
  }

  function moveHero(dir) {
    var slides = [].slice.call(document.querySelectorAll(".slideshow__slide"));
    if (!slides.length) return;
    slides[heroIndex].classList.remove("is-active");
    heroIndex = (heroIndex + dir + slides.length) % slides.length;
    slides[heroIndex].classList.add("is-active");
    syncHeroTrackLayout();
    resetHeroAutoplay();
  }

  function startHeroAutoplay() {
    clearInterval(heroTimer);
    heroTimer = setInterval(function () { moveHero(1); }, 8000);
  }
  function resetHeroAutoplay() {
    startHeroAutoplay();
  }

  function initScrollButtons() {
    function scrollCarousel(btn, direction) {
      var attr = direction < 0 ? "data-scroll-prev" : "data-scroll-next";
      var el = document.getElementById(btn.getAttribute(attr));
      if (!el) return;
      var card = el.querySelector(".product-card");
      var gap = parseFloat(getComputedStyle(el).gap) || 16;
      var step = card ? card.offsetWidth + gap : el.clientWidth * 0.8;
      el.scrollBy({ left: direction * step, behavior: "smooth" });
    }

    document.querySelectorAll("[data-scroll-prev]").forEach(function (btn) {
      btn.addEventListener("click", function () { scrollCarousel(btn, -1); });
    });
    document.querySelectorAll("[data-scroll-next]").forEach(function (btn) {
      btn.addEventListener("click", function () { scrollCarousel(btn, 1); });
    });
  }

  function storyVideoPoster(story) {
    if (story.poster) return story.poster;
    if (!story.video) return "";
    return story.video.replace(/([^/]+)\.mp4$/, "posters/$1-poster.jpg");
  }

  function storyMediaHtml(story, img) {
    if (story.video) {
      var posterSrc = storyVideoPoster(story);
      var poster = posterSrc
        ? '<img class="story-card__poster" src="' + esc(posterSrc) + '" alt="" loading="lazy" />'
        : "";
      return (
        '<button type="button" class="story-card__cover story-card__cover--video" aria-label="Play ' + esc(story.quote) + ' video">' +
          '<div class="story-card__progress" aria-hidden="true"><span class="story-card__progress-bar"></span></div>' +
          poster +
          '<video class="story-card__video" src="' + esc(story.video) + '" muted playsinline preload="none"' +
            (posterSrc ? ' poster="' + esc(posterSrc) + '"' : "") +
          "></video>" +
          '<span class="story-card__shade" aria-hidden="true"></span>' +
        "</button>"
      );
    }
    return img ? '<img src="' + esc(img) + '" alt="" loading="lazy" />' : "";
  }

  function storyCardHtml(story, p, img) {
    if (!p) return "";
    var href = productHref(story.handle);
    return (
      '<article class="story-card">' +
        '<div class="story-card__media">' +
          storyMediaHtml(story, img) +
        "</div>" +
        '<div class="story-slide__product">' +
          '<div class="story-slide__product-header">' +
            (img ? '<img class="story-slide__product-img" src="' + esc(img) + '" alt="" width="96" height="96" loading="lazy" />' : "") +
            '<div class="story-slide__product-meta">' +
              '<strong class="story-slide__product-heading heading">' +
                '<a href="' + esc(href) + '"' + productLinkTarget() + '>' + esc(p.displayName) + "</a>" +
              "</strong>" +
              (story.tagline ? '<p class="story-slide__product-tagline">' + esc(titleCase(story.tagline)) + "</p>" : "") +
            "</div>" +
          "</div>" +
          '<div class="story-slide__product-content">' +
            '<a class="btn-shop story-slide__shop-btn" href="' + esc(href) + '"' + productLinkTarget() + ">Shop Now</a>" +
          "</div>" +
        "</div>" +
      "</article>"
    );
  }

  function getStoryVideoCards(carousel) {
    return Array.prototype.filter.call(carousel.querySelectorAll(".story-card"), function (card) {
      return card.querySelector(".story-card__video");
    });
  }

  function isStoryCardVisible(card, carousel) {
    if (!carousel || !card) return true;
    var carouselRect = carousel.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();
    return cardRect.left >= carouselRect.left - 12 && cardRect.right <= carouselRect.right + 12;
  }

  function preloadStoryVideo(video) {
    if (!video || video.dataset.preloaded === "1") return;
    video.preload = "auto";
    if (video.readyState < 1) video.load();
    video.dataset.preloaded = "1";
  }

  function preloadAdjacentStoryVideos(carousel, card) {
    var videoCards = getStoryVideoCards(carousel);
    var index = videoCards.indexOf(card);
    if (index < 0) return;
    var nextCard = videoCards[index + 1] || videoCards[0];
    if (nextCard && nextCard !== card) {
      preloadStoryVideo(nextCard.querySelector(".story-card__video"));
    }
  }

  function pauseStoryVideo(card) {
    if (!card) return;
    var cover = card.querySelector(".story-card__cover--video");
    var video = card.querySelector(".story-card__video");
    var bar = card.querySelector(".story-card__progress-bar");
    if (video) {
      video.pause();
      video.currentTime = 0;
    }
    if (cover) cover.classList.remove("is-playing");
    if (bar) bar.style.transform = "scaleX(0)";
  }

  function playStoryVideo(card) {
    if (!card) return;
    var cover = card.querySelector(".story-card__cover--video");
    var video = card.querySelector(".story-card__video");
    if (!video) return;

    var carousel = document.getElementById("story-carousel");
    clearTimeout(storyAutoplayTimer);
    storyActiveCard = card;

    if (carousel) {
      carousel.querySelectorAll(".story-card").forEach(function (other) {
        if (other !== card) pauseStoryVideo(other);
      });
      if (!isStoryCardVisible(card, carousel)) {
        scrollStoryToCard(card, "auto");
      }
      preloadAdjacentStoryVideos(carousel, card);
    }

    preloadStoryVideo(video);

    function startPlayback() {
      if (storyActiveCard !== card) return;
      video.currentTime = 0;
      cover && cover.classList.add("is-playing");
      video.play().catch(function () {
        if (storyActiveCard === card) storyActiveCard = null;
        cover && cover.classList.remove("is-playing");
      });
    }

    if (video.readyState >= 3) {
      startPlayback();
      return;
    }

    var onCanPlay = function () {
      video.removeEventListener("canplay", onCanPlay);
      startPlayback();
    };
    video.addEventListener("canplay", onCanPlay);
  }

  function getStoryMaxScroll(carousel) {
    var cards = carousel.querySelectorAll(".story-card");
    if (!cards.length) return 0;

    var lastCard = cards[cards.length - 1];
    var styles = window.getComputedStyle(carousel);
    var trailingGutter = parseFloat(styles.paddingRight) || 0;
    var contentEnd = lastCard.offsetLeft + lastCard.offsetWidth + trailingGutter;

    return Math.max(0, contentEnd - carousel.clientWidth);
  }

  function clampStoryCarouselScroll(carousel) {
    if (!carousel) return;
    var maxScroll = getStoryMaxScroll(carousel);
    if (carousel.scrollLeft > maxScroll) {
      carousel.scrollLeft = maxScroll;
    }
  }

  function scrollStoryToCard(card, behavior) {
    var carousel = document.getElementById("story-carousel");
    if (!carousel || !card) return;

    var maxScroll = getStoryMaxScroll(carousel);
    var carouselRect = carousel.getBoundingClientRect();
    var cardRect = card.getBoundingClientRect();
    var viewWidth = carousel.clientWidth;

    // Align clicked card to the left edge of the visible carousel area.
    var target = carousel.scrollLeft + (cardRect.left - carouselRect.left);

    // If the card would still clip on the right (e.g. near the end), shift back.
    var cardEnd = card.offsetLeft + card.offsetWidth;
    if (target + viewWidth < cardEnd) {
      target = cardEnd - viewWidth;
    }

    target = Math.max(0, Math.min(target, maxScroll));
    carousel.scrollTo({ left: target, behavior: behavior || "smooth" });
  }

  function advanceStoryVideo(carousel) {
    var videoCards = getStoryVideoCards(carousel);
    if (!videoCards.length) return;

    var currentIndex = storyActiveCard ? videoCards.indexOf(storyActiveCard) : -1;
    var nextIndex = currentIndex + 1;
    if (nextIndex >= videoCards.length) nextIndex = 0;

    var nextCard = videoCards[nextIndex];
    clearTimeout(storyAutoplayTimer);
    storyAutoplayTimer = setTimeout(function () {
      playStoryVideo(nextCard);
    }, 450);
  }

  function startStoryAutoplay(carousel) {
    var videoCards = getStoryVideoCards(carousel);
    if (!videoCards.length) return;

    carousel.querySelectorAll(".story-card").forEach(pauseStoryVideo);
    clearTimeout(storyAutoplayTimer);
    preloadStoryVideo(videoCards[0].querySelector(".story-card__video"));
    if (videoCards[1]) preloadStoryVideo(videoCards[1].querySelector(".story-card__video"));
    storyAutoplayTimer = setTimeout(function () {
      playStoryVideo(videoCards[0]);
    }, 200);
  }

  function bindStoryCarouselVideos(carousel) {
    carousel.querySelectorAll(".story-card").forEach(function (card) {
      var cover = card.querySelector(".story-card__cover--video");
      var video = card.querySelector(".story-card__video");
      if (!video || video.dataset.bound === "1") return;
      video.dataset.bound = "1";

      if (cover && cover.dataset.clickBound !== "1") {
        cover.dataset.clickBound = "1";
        cover.addEventListener("click", function () {
          playStoryVideo(card);
        });
      }

      var progressRaf = 0;
      video.addEventListener("timeupdate", function () {
        if (storyActiveCard !== card || !video.duration || progressRaf) return;
        progressRaf = requestAnimationFrame(function () {
          progressRaf = 0;
          if (storyActiveCard !== card || !video.duration) return;
          var bar = card.querySelector(".story-card__progress-bar");
          if (bar) bar.style.transform = "scaleX(" + (video.currentTime / video.duration) + ")";
        });
      });

      video.addEventListener("ended", function () {
        if (storyActiveCard !== card) return;
        advanceStoryVideo(carousel);
      });

      video.addEventListener("playing", function () {
        var cover = card.querySelector(".story-card__cover--video");
        if (cover) cover.classList.add("is-playing");
      });
    });
  }

  function scrollCarouselFromTrackPosition(carousel, track, thumb, clientX) {
    var maxScroll = getStoryMaxScroll(carousel);
    if (maxScroll <= 0) return;

    var rect = track.getBoundingClientRect();
    var trackWidth = track.clientWidth;
    var thumbWidth = thumb.offsetWidth;
    var maxThumbTravel = Math.max(0, trackWidth - thumbWidth);
    var clickX = clientX - rect.left;
    var thumbOffset = Math.max(0, Math.min(maxThumbTravel, clickX - thumbWidth / 2));
    var ratio = maxThumbTravel ? thumbOffset / maxThumbTravel : 0;

    carousel.scrollLeft = ratio * maxScroll;
  }

  function initStoryCarouselScrollbarInteraction(carousel) {
    var track = document.querySelector(".story-carousel-scrolltrack");
    var thumb = document.getElementById("story-carousel-thumb");
    if (!carousel || !track || !thumb || track.dataset.interactionBound === "1") return;
    track.dataset.interactionBound = "1";

    var dragState = null;

    function endDrag() {
      if (!dragState) return;
      dragState = null;
      track.classList.remove("is-dragging");
      document.removeEventListener("pointermove", onPointerMove);
      document.removeEventListener("pointerup", endDrag);
      document.removeEventListener("pointercancel", endDrag);
    }

    function onPointerMove(e) {
      if (!dragState) return;
      e.preventDefault();

      var maxScroll = getStoryMaxScroll(carousel);
      var trackWidth = track.clientWidth;
      var thumbWidth = thumb.offsetWidth;
      var maxThumbTravel = Math.max(0, trackWidth - thumbWidth);
      if (!maxThumbTravel) return;

      var deltaX = e.clientX - dragState.startX;
      var thumbOffset = Math.max(0, Math.min(maxThumbTravel, dragState.startThumbOffset + deltaX));
      var ratio = thumbOffset / maxThumbTravel;
      carousel.scrollLeft = ratio * maxScroll;
    }

    thumb.addEventListener("pointerdown", function (e) {
      if (getStoryMaxScroll(carousel) <= 0) return;

      dragState = {
        startX: e.clientX,
        startThumbOffset: thumb.getBoundingClientRect().left - track.getBoundingClientRect().left,
      };
      track.classList.add("is-dragging");
      try {
        thumb.setPointerCapture(e.pointerId);
      } catch (err) {}

      document.addEventListener("pointermove", onPointerMove);
      document.addEventListener("pointerup", endDrag);
      document.addEventListener("pointercancel", endDrag);
      e.preventDefault();
    });

    track.addEventListener("pointerdown", function (e) {
      if (e.target === thumb) return;
      if (getStoryMaxScroll(carousel) <= 0) return;

      scrollCarouselFromTrackPosition(carousel, track, thumb, e.clientX);
      e.preventDefault();
    });
  }

  function syncStoryCarouselScrollbar(carousel) {
    var track = document.querySelector(".story-carousel-scrolltrack");
    var thumb = document.getElementById("story-carousel-thumb");
    if (!carousel || !track || !thumb) return;

    var maxScroll = getStoryMaxScroll(carousel);
    if (maxScroll <= 0) {
      track.style.visibility = "hidden";
      return;
    }

    track.style.visibility = "visible";
    var trackWidth = track.clientWidth;
    var thumbWidth = Math.max(28, (carousel.clientWidth / carousel.scrollWidth) * trackWidth);
    thumb.style.width = thumbWidth + "px";

    var maxThumbTravel = Math.max(0, trackWidth - thumbWidth);
    var thumbOffset = maxScroll ? (carousel.scrollLeft / maxScroll) * maxThumbTravel : 0;
    thumb.style.transform = "translateX(" + thumbOffset + "px)";
  }

  function initStoryCarouselScroll(carousel) {
    if (carousel.dataset.scrollBound === "1") return;
    carousel.dataset.scrollBound = "1";

    carousel.addEventListener("scroll", function () {
      clampStoryCarouselScroll(carousel);
      syncStoryCarouselScrollbar(carousel);
    }, { passive: true });

    window.addEventListener("resize", function () {
      clampStoryCarouselScroll(carousel);
      syncStoryCarouselScrollbar(carousel);
    });

    syncStoryCarouselScrollbar(carousel);
    initStoryCarouselScrollbarInteraction(carousel);
  }

  function renderStories(rows) {
    var carousel = document.getElementById("story-carousel");
    if (!carousel) return;

    clearTimeout(storyAutoplayTimer);
    carousel.innerHTML = rows.map(function (row) {
      return storyCardHtml(row.story, row.p, row.img);
    }).join("");

    carousel.scrollLeft = 0;
    bindStoryCarouselVideos(carousel);
    initStoryCarouselScroll(carousel);
    requestAnimationFrame(function () {
      clampStoryCarouselScroll(carousel);
      syncStoryCarouselScrollbar(carousel);
    });
    storyActiveCard = null;
    startStoryAutoplay(carousel);
  }

  function initStories() {
    var rows = STORIES.map(function (story) {
      var p = catalog.find(function (item) { return item.handle === story.handle; });
      return {
        story: story,
        p: p,
        img: productImage(p, shopProducts[p.handle] || null),
      };
    }).filter(function (row) { return row.p; });

    storyActiveCard = null;
    renderStories(rows);

    Promise.all(STORIES.map(function (story) {
      return fetchShopify(story.handle).then(function (s) {
        return {
          story: story,
          s: s,
          p: catalog.find(function (item) { return item.handle === story.handle; }),
        };
      });
    })).then(function (fetched) {
      var nextRows = fetched.map(function (row) {
        return {
          story: row.story,
          p: row.p,
          img: productImage(row.p, row.s),
        };
      }).filter(function (row) { return row.p; });

      storyActiveCard = null;
      renderStories(nextRows);
    });
  }

  function getGroupProducts(group) {
    if (group.line) {
      return catalog.filter(function (p) {
        return p.line === group.line;
      });
    }
    if (!group.handles) {
      /* All Products: Balance Line first, then Deficiency Line, then anything else */
      var balance = catalog.filter(function (p) {
        return p.line === "feminine-balance";
      });
      var deficiency = catalog.filter(function (p) {
        return p.line === "fembal-deficiency";
      });
      var other = catalog.filter(function (p) {
        return p.line !== "feminine-balance" && p.line !== "fembal-deficiency";
      });
      return balance.concat(deficiency).concat(other);
    }
    return group.handles
      .map(function (h) {
        return catalog.find(function (p) {
          return p.handle === h;
        });
      })
      .filter(Boolean);
  }

  function renderBenefitPanel(group) {
    var carouselId = "benefit-carousel-" + group.id;
    return (
      '<div class="benefit-panel" id="panel-' + group.id + '" role="tabpanel">' +
        '<div class="carousel-wrap">' +
          '<div class="carousel-nav carousel-nav--prev">' +
            '<button type="button" class="circle-btn" data-scroll-prev="' + esc(carouselId) + '" aria-label="Previous products">' +
              CAROUSEL_ARROW_PREV +
            "</button>" +
          "</div>" +
          '<div class="scroll-carousel" id="' + esc(carouselId) + '" data-panel-carousel="' + esc(group.id) + '"></div>' +
          '<div class="carousel-nav carousel-nav--next">' +
            '<button type="button" class="circle-btn" data-scroll-next="' + esc(carouselId) + '" aria-label="Next products">' +
              CAROUSEL_ARROW_NEXT +
            "</button>" +
          "</div>" +
        "</div>" +
      "</div>"
    );
  }

  function initBenefitTabs() {
    var tabsEl = document.getElementById("benefit-tabs");
    var panelsEl = document.getElementById("benefit-panels");

    tabsEl.innerHTML = BENEFIT_GROUPS.map(function (g, i) {
      return (
        '<button type="button" class="benefit-tab' + (i === 0 ? " is-active" : "") + '" role="tab" ' +
        'aria-selected="' + (i === 0 ? "true" : "false") + '" data-tab="' + esc(g.id) + '">' +
        esc(g.label) + "</button>"
      );
    }).join("");

    panelsEl.innerHTML = BENEFIT_GROUPS.map(renderBenefitPanel).join("");
    panelsEl.querySelector(".benefit-panel").classList.add("is-active");

    BENEFIT_GROUPS.forEach(function (g) {
      var carousel = panelsEl.querySelector('[data-panel-carousel="' + g.id + '"]');
      var products = getGroupProducts(g);
      carousel.innerHTML = products.map(function (p) {
        return productCard(p, shopProducts[p.handle] || null);
      }).join("");

      Promise.all(products.map(function (p) {
        return fetchShopify(p.handle).then(function (s) { return { p: p, s: s }; });
      })).then(function (rows) {
        carousel.innerHTML = rows.map(function (r) { return productCard(r.p, r.s); }).join("");
      });
    });

    tabsEl.addEventListener("click", function (e) {
      var tab = e.target.closest(".benefit-tab");
      if (!tab) return;
      var id = tab.getAttribute("data-tab");
      tabsEl.querySelectorAll(".benefit-tab").forEach(function (t) {
        var on = t === tab;
        t.classList.toggle("is-active", on);
        t.setAttribute("aria-selected", on ? "true" : "false");
      });
      panelsEl.querySelectorAll(".benefit-panel").forEach(function (p) {
        p.classList.toggle("is-active", p.id === "panel-" + id);
      });
    });
  }

  function initClinicalResults() {
    var block = document.querySelector("[data-clinical-results]");
    if (!block || !("IntersectionObserver" in window)) return;
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            block.classList.add("animating");
            observer.disconnect();
          }
        });
      },
      { threshold: 0.25 }
    );
    observer.observe(block);
  }

  function getStickyHeaderHeight() {
    var header = document.querySelector(".header");
    return header ? header.offsetHeight : 72;
  }

  function syncLayoutHeights() {
    var tag = document.querySelector(".preview-tag");
    var header = document.querySelector(".header");
    var announce = document.querySelector(".announce-bar");
    var navH = header ? header.offsetHeight : 72;
    var announceH = announce ? announce.offsetHeight : 0;
    var tagH = tag ? tag.offsetHeight : 0;

    document.documentElement.style.setProperty("--home-sticky-header-h", navH + "px");
    document.documentElement.style.setProperty("--v4-header-stack-h", navH + "px");
    document.documentElement.style.setProperty("--v4-pdp-sticky-top", (navH + 24) + "px");
    document.documentElement.style.setProperty("--home-hero-offset", (tagH + announceH + navH) + "px");
    syncHeroTrackLayout();
  }

  /* Sections filled async — scroll before render lands on the wrong block (e.g. bestsellers). */
  var DEFERRED_SCROLL_SECTIONS = ["shop-by-benefit"];

  function scrollToSection(el, behavior) {
    if (!el) return;
    var top = el.getBoundingClientRect().top + window.pageYOffset - getStickyHeaderHeight();
    window.scrollTo({ top: Math.max(0, top), behavior: behavior || "smooth" });
  }

  function scrollToSectionById(id, behavior) {
    var target = document.getElementById(id);
    if (!target) return false;
    scrollToSection(target, behavior);
    return true;
  }

  function isHomePath(pathname) {
    return pathname === "/" || pathname === "";
  }

  function resolveHomeSectionId(href) {
    if (!href) return null;
    if (href.charAt(0) === "#") {
      var hashId = href.slice(1);
      return hashId || null;
    }
    if (href.indexOf("/#") === 0) {
      var rootId = href.slice(2);
      return rootId || null;
    }
    try {
      var url = new URL(href, window.location.origin);
      if (url.origin === window.location.origin && isHomePath(url.pathname) && url.hash.length > 1) {
        return url.hash.slice(1);
      }
    } catch (err) {}
    return null;
  }

  function scrollPendingHash() {
    var pendingHash = window.FB_PENDING_HASH || location.hash;
    if (!pendingHash || pendingHash.length <= 1) return false;
    var sectionId = pendingHash.charAt(0) === "#" ? pendingHash.slice(1) : pendingHash;
    if (DEFERRED_SCROLL_SECTIONS.indexOf(sectionId) >= 0 && !window.FB_HOME_CATALOG_READY) {
      return true;
    }
    var hashTarget = document.getElementById(sectionId);
    if (!hashTarget) return false;
    requestAnimationFrame(function () {
      scrollToSection(hashTarget, "auto");
    });
    window.FB_PENDING_HASH = "";
    return true;
  }

  function finishDeferredHomeScroll() {
    window.FB_HOME_CATALOG_READY = true;
    var pendingHash = window.FB_PENDING_HASH;
    if (!pendingHash || pendingHash.length <= 1) return;
    var sectionId = pendingHash.charAt(0) === "#" ? pendingHash.slice(1) : pendingHash;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        if (scrollToSectionById(sectionId, "auto")) {
          window.FB_PENDING_HASH = "";
        }
      });
    });
  }

  window.FBScrollToHomeSection = function (id, behavior) {
    function run() {
      if (!scrollToSectionById(id, behavior || "smooth")) return;
      if (history.replaceState) {
        history.replaceState(null, "", "#" + id);
      }
    }
    if (DEFERRED_SCROLL_SECTIONS.indexOf(id) >= 0 && !window.FB_HOME_CATALOG_READY) {
      window.FB_PENDING_HASH = "#" + id;
      return;
    }
    run();
  };

  function initSectionAnchorScroll() {
    syncLayoutHeights();
    window.addEventListener("resize", syncLayoutHeights);

    if (!scrollPendingHash()) {
      window.scrollTo(0, 0);
    }

    document.addEventListener("click", function (e) {
      var link = e.target.closest("a[href]");
      if (!link) return;
      if (link.closest("[data-overlay-close]")) return;
      if (!isHomePath(window.location.pathname)) return;

      var sectionId = resolveHomeSectionId(link.getAttribute("href"));
      if (!sectionId) return;
      var target = document.getElementById(sectionId);
      if (!target) return;

      e.preventDefault();
      scrollToSection(target);
      if (history.pushState) {
        history.pushState(null, "", "#" + sectionId);
      }
    });
  }

  function initWellnessIcons() {
    initSnapCarousel(
      document.getElementById("wellness-icons-carousel"),
      document.getElementById("wellness-icons-dots"),
      ".text-with-icons__item",
      5000
    );
  }

  syncLayoutHeights();
  initWellnessIcons();
  initSectionAnchorScroll();

  Promise.all([
    fetch(window.FB_SHOP_PRODUCTS_URL || "/shop-products.json").then(function (r) { return r.ok ? r.json() : { products: {} }; }),
    fetch(window.FB_PDP_HERO_IMAGES_URL || "/pdp-hero-images.json").then(function (r) { return r.ok ? r.json() : {}; }),
    fetch(window.FB_PDP_HOVER_IMAGES_URL || "/pdp-hover-images.json").then(function (r) { return r.ok ? r.json() : {}; }),
    fetch(window.FB_CATALOG_URL || "/catalog.json").then(function (r) { return r.json(); }),
  ])
    .then(function (results) {
      shopProducts = (results[0] && results[0].products) || {};
      pdpHeroImages = results[1] || {};
      pdpHoverImages = results[2] || {};
      catalog = (results[3] && results[3].products) || [];
      renderCarousel(document.getElementById("bestsellers-grid"), BEST_SELLERS, { featured: true });
      initHero();
      initStories();
      initBenefitTabs();
      initScrollButtons();
      initClinicalResults();
      finishDeferredHomeScroll();
    })
    .catch(function () {
      finishDeferredHomeScroll();
    });
})();
